import {
    FETCH_YARN_INFORMATION_REQUEST,
    FETCH_YARN_INFORMATION_SUCCESS,
    FETCH_YARN_INFORMATION_FAILURE,
    CREATE_YARN_INFORMATION_FORM,
    UPDATE_YARN_INFORMATION_FORM,
    CREATE_YARN_INFORMATION_SUCCESS,
    FETCH_SINGLE_YARN_INFORMATION_SUCCESS,
    UPDATE_YARN_INFORMATION_SUCCESS,
    DELETE_YARN_INFORMATION_SUCCESS,
    CREATE_YARN_INFORMATION_REQUEST,
    UPDATE_YARN_INFORMATION_REQUEST,
    FETCH_SINGLE_YARN_INFORMATION_REQUEST,
    DELETE_YARN_INFORMATION_REQUEST,
    RESET_YARN_INFORMATION_INFO,
    CREATE_YARN_INFORMATION_FAILURE,
    UPDATE_YARN_INFORMATION_FAILURE,
    FETCH_SINGLE_YARN_INFORMATION_FAILURE,
    DELETE_YARN_INFORMATION_FAILURE,
    FETCH_YARN_BY_STYLE_DETAIL_ID_SUCCESS,
    FETCH_YARN_BY_STYLE_DETAIL_ID_REQUEST,
    FETCH_YARN_BY_STYLE_DETAIL_ID_FAILURE,
    FETCH_YARN_MASTER_WITHOUT_STYLE_SUCCESS,
    FETCH_YARN_MASTER_WITHOUT_STYLE_REQUEST,
    FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_REQUEST,
    FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_SUCCESS,
    FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_FAILURE,
    FETCH_YARN_MASTER_BY_STYLE_REQUEST,
    FETCH_YARN_MASTER_BY_STYLE_FAILURE,
    FETCH_YARN_MASTER_BY_STYLE_SUCCESS
} from './yarnInformation.actionsType';

export const YARN_INFORMATION = 'yarnInformation';

let initialState = {
    loading: false,
    yarnInformationList: [],
    yarnInformationListByStyleDetailId: [],
    yarnInformationListByStyleDetailIdWithGroupDistinct: [],
    yarnInformationForm: {
        fldFKYarnType: []
    },
    yarnMasterWithoutStyle: [],
    yarnMasterWithStyle: [],
    selectedState: {},
    errorMessage: '',
    deleteYarnId: ''

};

export let yarnInformationReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_YARN_INFORMATION_REQUEST:
        case CREATE_YARN_INFORMATION_REQUEST:
        case UPDATE_YARN_INFORMATION_REQUEST:
        case FETCH_SINGLE_YARN_INFORMATION_REQUEST:
        case FETCH_YARN_BY_STYLE_DETAIL_ID_REQUEST:
        case FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_REQUEST:
        case FETCH_YARN_MASTER_WITHOUT_STYLE_REQUEST:
        case DELETE_YARN_INFORMATION_REQUEST:
        case FETCH_YARN_MASTER_BY_STYLE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInformationList: updatePayload
            };
        case FETCH_YARN_MASTER_WITHOUT_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnMasterWithoutStyle: updatePayload
            };
        case FETCH_YARN_MASTER_BY_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnMasterWithStyle: updatePayload
            };
        case FETCH_YARN_BY_STYLE_DETAIL_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInformationListByStyleDetailId: updatePayload
            };
        case FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInformationListByStyleDetailIdWithGroupDistinct: updatePayload
            };
        case CREATE_YARN_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInformationForm: {
                    fldFKYarnType: []
                },
                yarnMasterWithoutStyle: [],
                yarnMasterWithStyle: []
            };
        case UPDATE_YARN_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInformationForm: {
                    fldFKYarnType: []
                }
            };
        case FETCH_SINGLE_YARN_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInformationForm: updatePayload
            };
        case DELETE_YARN_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                deleteYarnId: updatePayload,
                yarnInformationForm: {
                    fldFKYarnType: []
                }
            };
        case RESET_YARN_INFORMATION_INFO:
            return {
                ...state,
                yarnInformationForm: {
                    fldFKYarnType: []
                },
                deleteYarnId: '',
            };
        case CREATE_YARN_INFORMATION_FORM:
        case UPDATE_YARN_INFORMATION_FORM:
            return {
                ...state,
                loading: false,
                yarnInformationForm: {
                    ...state.yarnInformationForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_YARN_BY_STYLE_DETAIL_ID_FAILURE:
            return {
                yarnInformationListByStyleDetailId: [],
                ...state,
                loading: false
            };
        case FETCH_YARN_BY_STYLE_DETAIL_ID_WITH_GROUP_DISTINCT_FAILURE:
            return {
                yarnInformationListByStyleDetailIdWithGroupDistinct: [],
                ...state,
                loading: false
            };
        case FETCH_YARN_INFORMATION_FAILURE:
        case CREATE_YARN_INFORMATION_FAILURE:
        case UPDATE_YARN_INFORMATION_FAILURE:
        case FETCH_SINGLE_YARN_INFORMATION_FAILURE:
        case DELETE_YARN_INFORMATION_FAILURE:
        case FETCH_YARN_INFORMATION_FAILURE:
        case FETCH_YARN_MASTER_BY_STYLE_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
